"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var lodash_1 = require("lodash");

var core_1 = require("@bodiless/core");

var fclasses_1 = require("@bodiless/fclasses");

var react_1 = require("react");

var asBodilessLink_1 = __importDefault(require("./Link/asBodilessLink"));

var Toggle_1 = require("./Toggle");

var EmptyToggle = lodash_1.flowRight(core_1.ifEditable(Toggle_1.withWrapOnSubmit, asBodilessLink_1.default(), fclasses_1.replaceWith(fclasses_1.asComponent('span'))), core_1.ifReadOnly(core_1.withNode), core_1.withOnlyProps('key', 'children'))(react_1.Fragment);
var withLinkToggle = lodash_1.flowRight(fclasses_1.stylable, core_1.ifEditable(fclasses_1.addProps({
  'aria-label': 'Link Toggle'
})), core_1.withNode, Toggle_1.withToggleTo(EmptyToggle));
exports.default = withLinkToggle;